export default __webpack_public_path__ + "static/media/approve-success.6d43a268.svg";